// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5t-1";
export var standaloneTable = "_5t-0";